import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useRef,
} from 'react';

const OverlayContext = createContext(null);

export function OverlayProvider({ children }) {
  const openCountRef = useRef(0);

  const registerOverlay = useCallback(() => {
    openCountRef.current += 1;
    if (openCountRef.current === 1 && typeof document !== 'undefined') {
      document.body.dataset.overlayOpen = 'true';
      document.body.style.overflow = 'hidden';
    }
    return () => {
      openCountRef.current = Math.max(0, openCountRef.current - 1);
      if (openCountRef.current === 0 && typeof document !== 'undefined') {
        delete document.body.dataset.overlayOpen;
        document.body.style.overflow = '';
      }
    };
  }, []);

  const value = useMemo(() => ({ registerOverlay }), [registerOverlay]);

  return (
    <OverlayContext.Provider value={value}>{children}</OverlayContext.Provider>
  );
}

export function useOverlayRegistry() {
  return useContext(OverlayContext);
}
